import React, {
  useEffect, useLayoutEffect, useRef, useState,
} from 'react';
import ReactDOM from 'react-dom';
import cn from 'classnames';
import styles from './DropdownPanel.module.scss';

// Full width panel that drops down below anchorRef (the topbar row).
// Closes on Escape and on clicks outside the panel and triggerRef.
export const DropdownPanel = ({
  isOpen,
  anchorRef,
  triggerRef,
  onClose,
  onMouseEnter,
  onMouseLeave,
  className,
  children,
}) => {
  const panelRef = useRef(null);
  const [top, setTop] = useState(0);

  useLayoutEffect(() => {
    if (!isOpen) return undefined;
    const updateTop = () => {
      if (!anchorRef.current) return;
      setTop(anchorRef.current.getBoundingClientRect().bottom + window.scrollY);
    };
    updateTop();
    window.addEventListener('resize', updateTop);
    return () => window.removeEventListener('resize', updateTop);
  }, [isOpen, anchorRef]);

  useEffect(() => {
    if (!isOpen) return undefined;

    const isInside = (target) => [panelRef, triggerRef].some(
      (ref) => ref && ref.current && ref.current.contains(target),
    );
    const onMouseDown = (e) => {
      if (!isInside(e.target)) onClose();
    };
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };

    document.addEventListener('mousedown', onMouseDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [isOpen, onClose, triggerRef]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      ref={panelRef}
      className={cn(styles.panel, className)}
      style={{ top }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}>
      {children}
    </div>,
    document.body,
  );
};

export default DropdownPanel;
